import { mapMutations, mapGetters } from "vuex";
export default {
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods:{
    ...mapMutations({
      senduserInfo: "SENDuserInfo",
    }),
    weChatShare(option){
      let pageUrl = (!!window.__wxjs_is_wkwebview&&window.entryUrl)?window.entryUrl: window.location.href.split("#")[0];
      this.$post("/api/wechat/gzh/shareSign", { pageUrl: encodeURIComponent(pageUrl), type: this.appType })
        .then(res => {
          if(res.code == '200'){
            let resp = res.object.resp
            if(resp.resp_code =='0' && resp.resp_result=='0'){
              wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: resp.shareSign.appid, // 必填，公众号的唯一标识
                timestamp: resp.shareSign.timestamp, // 必填，生成签名的时间戳
                nonceStr: resp.shareSign.nonceStr, // 必填，生成签名的随机串
                signature: resp.shareSign.signature, // 必填，签名，见附录1
                jsApiList: ["updateAppMessageShareData", "updateTimelineShareData", "onMenuShareAppMessage", "onMenuShareTimeline", "chooseWXPay","previewImage"], // 所有要调用的 API 都要加到这个列表中
                openTagList: ['wx-open-launch-weapp'],
                success: function(res) {
                  // 回调
                },
                fail: function(res) {
                  if (res.errMsg.indexOf("function not exist") > -1) {
                    alert("版本过低请升级");
                  }
                }
              });
              wx.checkJsApi({
                jsApiList: ["updateAppMessageShareData", "updateTimelineShareData","onMenuShareAppMessage", "onMenuShareTimeline", 'chooseWXPay',"previewImage"], // 需要检测的JS接口列表，所有JS接口列表见附录2,
                success: function(res) {
                },
                error: res => {
                }
              });
              wx.ready(function() {
                wx.updateAppMessageShareData({
                  //分享给朋友
                  title: option.title, // 分享标题
                  desc: option.desc, // 分享描述
                  link: option.link , // 分享链接
                  imgUrl: option.images, // 分享图标
                  success: function() {
                    //用户确认分享后执行的回调函数
                  },
                  cancel: function() {
                    // 用户取消分享后执行的回调函数
                  }
                });
                wx.onMenuShareAppMessage({
                  //分享给朋友
                  title: option.title, // 分享标题
                  desc: option.desc, // 分享描述
                  link: option.link, // 分享链接
                  imgUrl: option.images, // 分享图标
                  success: function() {
                    //用户确认分享后执行的回调函数
                  },
                  cancel: function() {
                    // 用户取消分享后执行的回调函数
                  }
                });
                wx.updateTimelineShareData({
                  //分享到朋友圈
                  title: option.title, // 分享标题
                  link: option.link , // 分享链接
                  imgUrl: option.images, // 分享图标
                  success: function() {
                  },
                  cancel: function() {
                  }
                });
                wx.onMenuShareTimeline({
                  //分享到朋友圈
                  title: option.title, // 分享标题
                  link: option.link , // 分享链接
                  imgUrl: option.images, // 分享图标
                  success: function() {
                  },
                  cancel: function() {
                  }
                });
              });
            }
          }

        });
    },
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
  },
}



// WEBPACK FOOTER //
// ./src/assets/js/weChatShare.js